import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/pied-piper': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M32 419l-32 60.2 0.8-328c0-65.9 53.2-119.2 119.2-119.2h327.2c-93 28.9-189.9 94.2-253.9 168.6-70.6 81.4-110.7 137.4-161.3 218.4zM448 32c0 0 0 328.8 0.1 328.8 0 65.9-53.3 119.2-119.3 119.2h-328.4c18.5-25.5 61.7-54 84.9-66 35.5-18.1 76.4-28.5 105.3-56.3 42.1-40.5 47.8-105 71-158.6 43.6-100.3 186.4-167.1 186.4-167.1z'
      }
    ]
  }
})
